import { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { ASSISTANTS } from "@/data/content";
import { StatusPill } from "@/components/site/Section";

export const AssistantsCarousel = () => {
  const [api, setApi] = useState(null);
  useEffect(() => {
    if (!api) return;
    const t = setInterval(() => api.scrollNext(), 4000);
    return () => clearInterval(t);
  }, [api]);
  return (
    <Carousel setApi={setApi} opts={{ loop: true, align: "start" }} className="w-full" data-testid="assistants-carousel">
      <CarouselContent className="-ml-5">
        {ASSISTANTS.map((a, idx) => (
          <CarouselItem key={a.name} className="pl-5 basis-[85%] sm:basis-1/2 lg:basis-1/3 xl:basis-1/4">
            <div data-testid={`assistant-card-${idx}`} className="card-box h-full p-7 lift relative overflow-hidden">
              <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full blur-2xl opacity-30" style={{ background: a.color }} />
              <div className="relative flex items-center justify-between">
                <div className="h-12 w-12 rounded-xl flex items-center justify-center" style={{ background: `${a.color}22`, color: a.color }}>
                  <a.icon className="h-6 w-6" />
                </div>
                <StatusPill status={a.status} />
              </div>
              <h3 className="relative mt-6 text-lg font-semibold">{a.name}</h3>
              <p className="relative mt-2 text-sm text-muted-foreground leading-relaxed">{a.role}</p>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <div className="mt-8 flex gap-2">
        <CarouselPrevious data-testid="assistants-prev" className="static translate-y-0 rounded-full" />
        <CarouselNext data-testid="assistants-next" className="static translate-y-0 rounded-full" />
      </div>
    </Carousel>
  );
};
